import Button from "@material-ui/core/es/Button/Button";
import Checkbox from "@material-ui/core/es/Checkbox/Checkbox";
import FormControlLabel from "@material-ui/core/es/FormControlLabel/FormControlLabel";
import Radio from "@material-ui/core/es/Radio/Radio";
import RadioGroup from "@material-ui/core/es/RadioGroup/RadioGroup";
import Switch from "@material-ui/core/es/Switch/Switch";
import React from "react";
import {SegmentedControl} from "segmented-control";
import AlertDialog from "../components/AlertDialog";
import VLButton from "../components/VLButton";

import * as API from "../util/api";
import * as Util from "../util/util";
import VLScreen from "./VLScreen";

export default class BroadcastScreen extends VLScreen {

    constructor() {
        super();
        this.state = {
            loaded: false,
            error: null,
            message_title: "",
            message_body: "",
            target: "all",
            sensors: [],
            sending: false,
            target_app: 1
        };
    }

    componentDidMount() {
        this.load();
        if (this.props.id) {
            this.setState({[this.props.id + "checked"]: true, target: "specific"});
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.id !== this.props.id) {
            if (this.props.id) {
                this.setState({[this.props.id + "checked"]: true, target: "specific"});
            }
        }
    }

    load = () => {
        API.POST("systems/list", {}, result => {
            Util.handleLogout(result);
            if (result.success) {
                this.setState(result.result);
            } else {
                this.setState({error: result.error});
            }
            this.setState({loaded: true});
        });
    };

    title = () => "Broadcast";

    content() {
        const appOptions = [
            {label: "Community Viewer", value: 1, default: this.state.target_app == 1},
            {label: "System Viewer", value: 2, default: this.state.target_app == 2},
            {label: "Both", value: 3, default: this.state.target_app == 3}
        ];
        return (
            <div id="content" style={{
                display: "flex",
                width: "100%",
                padding: 16
            }}>
                {this.renderTextAlert()}
                <AlertDialog open={this.state.sending} title="Sending..."/>
                <div style={{flex: 25, padding: 0}}>
                    <div style={{height: "calc(100vh - 160px)", overflowY: "auto"}}>
                        <h2>Broadcast</h2>
                        <p className="nomargin">Send a broadcast to Smartphone App users.</p>
                        <br/>
                        <h3>Target</h3>
                        <SegmentedControl
                            name="target_app"
                            options={appOptions}
                            value={this.state.target_app}
                            setValue={target_app => this.setState({target_app})}
                            style={{color: window.primary}}/>
                        <RadioGroup onChange={this.handleInputChange} name="target" value={this.state.target}>
                            <FormControlLabel value="all" control={<Radio/>} label="All Systems"/>
                            <FormControlLabel value="specific" control={<Radio/>} label="Specific Systems"/>
                        </RadioGroup>
                        {this.renderTickBoxes()}
                    </div>
                </div>
                <div style={{width: 30}}/>
                <div style={{flex: 40, padding: 0}}>
                    {this.renderForm()}
                </div>
            </div>
        );
    }

    renderTickBoxes = () => {
        if (this.state.target === "all") return;
        let boxes = this.state.sensors.map(s => {
            const key = s.sensor_id + "checked";
            return <>
                <FormControlLabel
                    key={key}
                    control={
                        <Checkbox
                            onChange={this.handleInputChange}
                            checked={!!this.state[key]}
                            name={key}
                            value={key}
                            color="primary"
                        />
                    }
                    label={s.sensor_name}
                />
                <br/>
            </>;
        });
        return (
            <>
                <div style={{display: "flex", alignItems: "center", justifyContent: "space-between"}}>
                    <h3>Select Systems</h3>
                    <Button color="primary" onClick={this.clearTicks}>Clear</Button>
                </div>
                <br/>
                {boxes}
            </>
        );
    };

    clearTicks = () => {
        this.state.sensors.forEach(s => {
            const key = s.sensor_id + "checked";
            this.setState({[key]: false});
        });
    };

    getSelectedSensors = () => {
        return this.state.sensors.filter(s => {
            const key = s.sensor_id + "checked";
            return this.state[key];
        });
    };

    messageBody = () => this.state.message_body.trim();

    renderForm = () => {
        return (
            <>
                <div style={{display: "flex"}}>
                    <h3 className="nomargin" style={{flex: 1}}>Alert Title</h3>
                    <Button color="primary" onClick={() => this.setState({message_title: ""})}>Clear</Button>
                </div>
                <input className="vl-input wide top8" name="message_title" value={this.state.message_title} maxlength={100}
                       onChange={this.handleInputChange}/>

                <div style={{display: "flex"}}>
                    <h3 style={{margin: "8px 0 0 0", flex: 1}}>Alert Message</h3>
                    <Button color="primary" onClick={() => this.setState({message_body: ""})}>Clear</Button>
                </div>
                <textarea className="vl-input wide top8"
                          style={{resize: "none", height: "30vh", maxHeight: "calc(100vh - 460px)"}} name="message_body"
                          maxlength={500} value={this.state.message_body} onChange={this.handleInputChange}/>
                <p style={{color: (500 - this.messageBody().length) ? "#888" : "red"}}
                   className="nomargin">{(500 - this.messageBody().length)} characters</p>
                <div style={{display: "flex", alignItems: "center"}} className="wide">
                    <div style={{flex: 1}}>
                        <h3>High Priority</h3>
                        <p className="nomargin">This will force the users phone to trigger an audible alert even if
                            muted.</p>
                    </div>
                    <Switch name="high_priority" checked={this.state.high_priority} onChange={this.handleInputChange}/>
                </div>

                <br/>
                <br/>
                <VLButton title={this.sendTitle()} className="wide top8" onClick={this.send}/>
            </>
        );
    };

    sendTitle = () => {
        if (this.state.target === "all") {
            return "send to all";
        } else {
            return "send to selected systems (" + this.getSelectedSensors().length + ")";
        }
    };

    send = () => {
        let data = this.filterState(["message_title", "message_body", "high_priority"]);
        data.message_title = data.message_title.trim();
        data.message_body = data.message_body.trim();
        if (data.message_title.length === 0 || data.message_body.length === 0) {
            this.basicAlert("Please enter a title and message.");
            return;
        }
        if (this.state.target === "specific" && this.getSelectedSensors().length === 0) {
            this.basicAlert("Please select at least one system");
            return;
        }
        if (this.state.target === "specific") {
            data.target = JSON.stringify(this.getSelectedSensors().map(e => e.sensor_id));
        } else {
            data.target = "all";
        }

        data.target_app = this.state.target_app;

        this.showTextAlert("Are you sure you want to " + this.sendTitle() + "?", "", "Send", "Cancel", () => {
            data.high_priority = data.high_priority ? 1 : 0;
            console.log(data);
            this.setState({sending: true}, () => {
                API.POST("broadcasts/send", data, result => {
                    this.setState({sending: false}, () => {
                        if (result.success) {
                            this.basicAlert("Your message has been sent");
                        } else {
                            this.basicAlert("Message failed to send. " + result.error);
                        }
                    });
                });
            });
        }, true);
    };

}